export const postContentElementIds = {
  paidContentId: 'box1',
  freeContentId: 'box2',
  multiStateBoxId: 'multiStateBox1',
  richContentViewerId: 'richContentViewer5',
  paywallRichContentViewerId: 'richContentViewer4',
  paywallRichContentWrapper: 'box4',
} as const;
